import { render, staticRenderFns } from "./skill-detail.component.html?vue&type=template&id=e5697984&scoped=true&"
import script from "./skill-detail.component.ts?vue&type=script&lang=ts&"
export * from "./skill-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./skill-detail.component.scss?vue&type=style&index=0&id=e5697984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5697984",
  null
  
)

export default component.exports